import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./ContactSection.css";
import logo from "../../../assets/images/isotipo-invecasa.svg"; // Ajusta la ruta si es necesario

const ContactSection = () => {
  return (
    <section className="contact-section">
      <div className="contact-container">
        {/* 🔹 Lado izquierdo */}
        <div className="contact-left">
          <img src={logo} alt="INVESCASA Logo" className="contact-logo" />
          <h3>Contact us</h3>
        </div>

        {/* 🔹 Línea divisoria */}
        <div className="contact-divider"></div>

        {/* 🔹 Cuadrícula de contactos */}
        <div className="contact-grid">
          <div className="contact-item">
            <FaPhoneAlt className="contact-icon" />
            <a href="tel:+61370429340">+61 370 429 340</a>
          </div>

          <div className="contact-item">
            <FaMapMarkerAlt  className="contact-icon" />
            <span>
              MELBOURNE - Level 12, 412 St Kilda Road, Melbourne VIC 3004
            </span>
          </div>

          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <a href="mailto:info@invescasa.com.au">info@invescasa.com.au</a>
          </div>

          <div className="contact-item">
            <FaMapMarkerAlt className="contact-icon" />
            <span>
              ADELAIDE - 5/141-157 O’Connell Street, North Adelaide, SA 5006
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
